import React, { useEffect } from 'react';
import { Container, Typography, Button, Box, Card, CardMedia, Grid } from '@mui/material';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import { useNavigate } from 'react-router-dom';
import logo from '../../images/0819db8c82d9cffc3dd22bd091848a1f.png';
import { useDispatch } from 'react-redux';
import { resetState } from '../../store/reducers/utils';
import { useSelector } from 'react-redux';

function Finalizar() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const planoFreemium = '8ad3b371-1a50-ef11-acd3-0e6c0ab65689'
    const planoSelecionado = useSelector(state => state.plano?.planoSelecionado?.planoAssinaturaID);
    const respostaTroca = useSelector(state => state.plano?.respostaTroca);

    if (respostaTroca?.qrCode) navigate(`/checkoutpix`);

    useEffect(() => {
        dispatch(resetState());
    }, []);


    const handleAcesso = () => {
        window.location.href = 'https://meetings.hubspot.com/brenda-oliveira1/implementacao';
    };

    const styledTypography = {
        marginBottom: 2,
        display: 'block',
        fontSize: { xs: '24px', md: '2rem' },
        fontWeight: '800',
        lineHeight: { xs: '28px', md: '2.375rem' },
        p: '0 10px',
    }

    return (
        <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <Grid
                maxWidth="md"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    minHeight: '60vh',
                    margin: '60px 0',
                }}
                justifyContent={'center'}
            >
                <Box sx={{ textAlign: 'center' }}>
                    <Card
                        sx={{
                            mb: { xs: '5rem', md: '8rem' },
                            boxShadow: '0 0 0',
                        }}
                    >
                        <CardMedia
                            component={'img'}
                            sx={{
                                width: {
                                    xs: '60%',
                                    sm: '40%',
                                },
                                margin: '0 auto',
                            }}
                            image={logo}
                        />
                    </Card>
                    <TaskAltRoundedIcon sx={{ fontSize: { xs: '100px', md: '130px' }, color: '#FF9F10', marginBottom: 2 }} />
                    <Typography sx={styledTypography}>
                        Chegou a hora de acelerar seu delivery! <br /> Marque agora mesmo seu treinamento.
                    </Typography>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#FF9F0D',
                            '&:hover': { backgroundColor: '#e68a00' },
                            borderRadius: '10px',
                            p: '0.875rem',
                            width: { xs: '40%', md: '50%' },
                            fontSize: '1rem',
                            fontWeight: '800',
                        }}
                        onClick={handleAcesso}
                    >
                        Marcar
                    </Button>
                </Box>
            </Grid>
        </Container>
    );
}

export default Finalizar;
